import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store, persistor } from "Redux/Store";
import { PersistGate } from "redux-persist/integration/react";
import AppProvider from "Context/AppContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AppProvider>
        <App />
      </AppProvider>
    </PersistGate>
  </Provider>

  // <Provider store={store}>
  //   <App />
  // </Provider>
);

reportWebVitals((metric) => {
  console.log(`[web-vitals] ${metric.name}`, metric.value, metric);
});
